import React from 'react'
import cn from 'classnames'

import { SVGIcon } from 'shared/ui'

import { isEmpty } from 'util/arrays'
import storage from 'util/storage'

import RefreshButton from '../Sidebar/RefreshButton'
import Mailbox from './Mailbox'
import Starred from './Starred'

import styles from './styles.less'

class Leftnav extends React.PureComponent {
  DEFAULT_OPEN_SECTIONS = ['Starred', 'Folders'] // eslint-disable-line

  constructor(props) {
    super(props)
    this.state = {
      starredOpen: !props.mailboxId,
      expandedSections:
        storage.get('inbox-leftnav-open-sections') ||
        this.DEFAULT_OPEN_SECTIONS,
    }
  }

  onMailboxClick = () => {
    this.setState({ starredOpen: false })
  }

  onStarredClick = () => {
    this.setState({ starredOpen: true })
  }

  // When we first load the app
  //   - if we hit a ticket page
  //     - we expand the sidebar section for that ticket's mailbox
  //
  //   - if we hit a search page
  //     - if it has a mailbox ID in the URL
  //       - we open the corresponding Mailbox in the sidebar
  //     - if it is a pinned search (and they are visible)
  //       - we open the first section (assumes Pinned always at the top)
  //     - otherwise open All Inboxes, if you have the preference set
  //     - otherwise just expand the first item (Pinned Searches)
  //
  // This logic can be simplified further given;
  //
  // 1. The currentMailboxId won't be set if its a Pinned search (because we
  // remove mailbox when pinning a search).
  //
  // 2. Showing the very first section (Pinnned, All Inboxes or the first
  // Mailbox) will do otherwise.
  //
  // Thus
  //   - if the mailboxId is set, use its' index.
  //      - this includes All Inboxes which has a null ID,
  //   - Otherwise return 0 for the first section
  //
  getInitialExpandedSectionIndex = shouldShowStarredSearches => {
    const { mailboxes, currentMailboxId, mailboxIdFromTicket } = this.props
    const mailboxId = mailboxIdFromTicket || currentMailboxId

    if (!mailboxId) return 0

    const indexOffset = shouldShowStarredSearches ? 1 : 0
    const index =
      Math.max(0, mailboxes.findIndex(e => e.id === mailboxId)) + indexOffset

    return index
  }

  isSectionExpanded = sectionTitle =>
    this.state.expandedSections.includes(sectionTitle)

  expandSection = sectionTitle => {
    const { expandedSections: oldExpandedSections } = this.state
    const expandedSections = [...oldExpandedSections, sectionTitle]

    storage.set('inbox-leftnav-open-sections', expandedSections)
    this.setState({ expandedSections })
  }

  collapseSection = sectionTitle => {
    const { expandedSections: oldExpandedSections } = this.state
    const expandedSections = oldExpandedSections.filter(
      title => title !== sectionTitle
    )

    storage.set('inbox-leftnav-open-sections', expandedSections)
    this.setState({ expandedSections })
  }

  toggleSection = sectionTitle => {
    if (this.isSectionExpanded(sectionTitle)) {
      return this.collapseSection(sectionTitle)
    }
    return this.expandSection(sectionTitle)
  }

  toggleTeamSection = () => {
    this.toggleSection('Team')
  }
  toggleTagsSection = () => this.toggleSection('Tags')

  render() {
    const {
      canSeePinnedSearches,
      mailboxes,
      mailboxId,
      starredSearches,
      doOpenSearchPage,
      doStartSearchTimer,
      prefersUnifiedInbox,
    } = this.props
    const { starredOpen } = this.state
    if (!mailboxes) return null

    const shouldShowStarredSearches =
      canSeePinnedSearches && starredSearches && !isEmpty(starredSearches)
    const starredSearchesActive = shouldShowStarredSearches && starredOpen
    const wantsCompactMode = prefersUnifiedInbox && !shouldShowStarredSearches

    return (
      <div className={styles['left-nav']}>
        <div className="header">
          <h1>Inbox</h1>
          <RefreshButton />
        </div>

        <div
          className={cn('mailboxes', {
            'unified-compact': wantsCompactMode,
          })}
        >
          {shouldShowStarredSearches && (
            <div className="mailbox starred">
              <div className="name" onClick={this.onStarredClick}>
                <SVGIcon
                  className="starred-icon"
                  name="pin"
                  color="color.monochrome.white"
                  size={20}
                />
                <span className="text">Pinned</span>
              </div>
              {starredOpen && <Starred starredSearches={starredSearches} />}
            </div>
          )}
          {mailboxes.map(mailbox => {
            let isCurrent = false
            // when starred searches are open, all inboxes should remain closed
            if (!starredSearchesActive) {
              // in unified inbox mode, there unified inbox should always be active
              // in split inbox mode, only the current context mailbox should be open
              isCurrent = prefersUnifiedInbox || mailbox.id === mailboxId
            }
            return (
              <Mailbox
                key={mailbox.id || mailbox.name} // mailbox.id can be null (for 'All inboxes')
                onClick={this.onMailboxClick}
                mailbox={mailbox}
                mailboxId={mailbox.id}
                isCurrent={isCurrent}
                hideTitle={wantsCompactMode}
                isTeamSectionOpen={this.isSectionExpanded('Team')}
                isTagsSectionOpen={this.isSectionExpanded('Tags')}
                toggleTeamSection={this.toggleTeamSection}
                toggleTagsSection={this.toggleTagsSection}
                doOpenSearchPage={doOpenSearchPage}
                doStartSearchTimer={doStartSearchTimer}
              />
            )
          })}
        </div>
      </div>
    )
  }
}

export default Leftnav
